import HelperService from "../../services/helper-service";
import {AppRoutes, AttachmentTypes, BuildingOwnershipTypes, BuildingStatTypes} from "../../utils/constants";
import React, {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import BuildingStatWidgetContent from "./building-stat-widget-content";
import BuildingStatYieldWidget from "./building-stat-yield-widget";

export default function BuildingPortfolioCard({ building, ...props}) {
  const [cover, setCover] = useState(null);

  useEffect(()=>{
    if (building){
      let ci = HelperService.getObjByKey(building.attachments, 'attachment_type_id', AttachmentTypes.cover.val);
      setCover(ci ? ci : null);

    } else {
      setCover(null);
    }
  }, [building]);

  return (
    <>
      <div className="col-12 col-md-6 col-lg-4 mb-4">
        <div className="card h-100 p-relative">
          <div className="card-img-top" style={{height: '280px', overflow: 'hidden'}}>
            <Link to={AppRoutes.buildingsPortfolio.path+'/'+building.id}>
              {cover && <img src={cover?.url} alt="" className="img-fit" style={{height: '100%',width: '100%'}} />}
              {!cover && <img src="assets/images/bg-gradient.jpg" alt="" className="img-fit" style={{height: '100%',width: '100%'}} />}
            </Link>
          </div>
          <div className="card-body">
            <span className={`building-portfolio-badge badge badge-lg bg-${HelperService.getObjByKey(Object.values(BuildingOwnershipTypes), 'val', building.ownership_type).color}`}>
              {HelperService.getObjByKey(Object.values(BuildingOwnershipTypes), 'val', building.ownership_type).title}</span>
            <Link to={AppRoutes.buildingsPortfolio.path+'/'+building.id}>
              <h3>{building.title}</h3>
            </Link>
            <p className="card-text building-portfolio-text">{building.description}</p>
            <hr />
            <BuildingStatWidgetContent stat={HelperService.getObjByKey(Object.values(building.stats), 'type_sync_id', BuildingStatTypes.rent.val)} buildingId={building.id} />
            <hr />
            <BuildingStatYieldWidget containerClass={'col-sm-12'} stats={building.stats} buildingId={building.id} />
            <hr />
            <div className={'row'}>
            <BuildingStatWidgetContent containerClass={'col-sm-12'} stat={HelperService.getObjByKey(Object.values(building.stats), 'type_sync_id', BuildingStatTypes.buildingValue.val)} buildingId={building.id} />
            </div>
            <hr />
            <BuildingStatWidgetContent stat={HelperService.getObjByKey(Object.values(building.stats), 'type_sync_id', BuildingStatTypes.capacity.val)}
                                       second={HelperService.getObjByKey(Object.values(building.stats), 'type_sync_id', BuildingStatTypes.capacityReserved.val)}
                                       third={HelperService.getObjByKey(Object.values(building.stats), 'type_sync_id', BuildingStatTypes.capacityAccepted.val)}
                                       fourth={HelperService.getObjByKey(Object.values(building.stats), 'type_sync_id', BuildingStatTypes.capacityFree.val)}
                                       buildingId={building.id} />
          </div>
        </div>
      </div>

    </>
  );
}
